import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box } from "@gemini/core";
import { Tooltip, useTooltipTrigger } from "@gemini/ui";
import { useRef } from "react";
export const TooltipTrigger = ({ text, icon, tooltipProps, }) => {
    const ref = useRef(null);
    const { boxProps } = useTooltipTrigger(ref);
    return (_jsx(Box, { as: "button", ref: ref, cursor: "help", borderStyle: "none", ...boxProps, onClick: (e) => {
            e.preventDefault();
            e.stopPropagation();
        }, paddingVertical: "spacing.none", children: _jsxs(Box, { display: "flex", alignItems: "center", borderRadius: "radius.8", color: "color.content.light.default", paddingHorizontal: "spacing.4", paddingVertical: "spacing.8", typography: "typography.body.12.regular", ...tooltipProps, children: [text && _jsx(Box, { marginRight: "spacing.4", children: text }), icon] }) }));
};
export const TooltipInfos = ({ content, text, icon, tooltipProps, placement, }) => (_jsx(Tooltip, { content: content, placement: placement, children: _jsx(TooltipTrigger, { text: text, icon: icon, tooltipProps: tooltipProps }) }));
